<template>
  <modal name="modal-stock-fail" class="modal-stock-fail" ref="modal">
    <div slot="content">
      <div class="flex flex-wrap mt-2">
        <h3 class="w-full py-60px sm:px-30px lg:px-20 uppercase text-white font-semibold bg-error">
          <span v-html="messageText"></span>
        </h3>
        <ul class="stock-fail-list w-full sm:px-30px lg:px-20 mt-10 mb-2">
          <li v-for="item in items" :key="item.sku">
            <span class="stock-fail-sku">{{ item.sku }}</span>
            <span class="stock-fail-sep"> — </span>
            <span class="stock-fail-name">{{ item.name }}</span>
          </li>
        </ul>
        <div class="w-full text-center py-60px sm:px-30px lg:px-0 lg:py-0 relative mt-5 flex justify-center">
          <button-full @click.native="dismiss" class="bg-error font-bold">
            {{ confirmText }}
          </button-full>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import ButtonFull from 'theme/components/theme/ButtonFull'
import Modal from 'theme/components/core/Modal'

export default {
  name: 'StockFailPopup',
  data () {
    return {
      messageText: 'These item(s) don\'t have the quantity you requested. <br><br>Please reduce the amount or remove the item(s) to continue checkout.',
      confirmText: 'OK',
      items: [],
      resolvePromise: undefined
    }
  },
  methods: {
    open (opts = {}) {
      this.messageText = opts.messageText || this.messageText || 'Some of the items you\'ve selected don\'t have the requested stock'
      this.confirmText = opts.confirmText || 'OK'
      this.items = opts.items || []
      this.$refs.modal.toggle(true)
      return new Promise((res) => {
        this.resolvePromise = res
      })
    },
    close () {
      this.$refs.modal.toggle(false)
    },
    dismiss () {
      this.close()
      if (this.resolvePromise) {
        this.resolvePromise(true)
      }
    }
  },
  components: {
    ButtonFull,
    Modal
  }
}
</script>

<style lang="scss">
  .modal-stock-fail {
    .modal-container {
      width: 700px;
      max-width: 90vw;
    }

    .stock-fail-list {
      list-style: disc;
      padding-left: 1.5rem;
      max-height: 40vh;
      overflow-y: auto;
      text-align: left;

      li {
        margin-bottom: 0.5rem;
        line-height: 1.4;
      }

      .stock-fail-sku {
        font-weight: 600;
      }
    }
  }
</style>
